export interface CookieConsentPrefs {
    version: number;
    decidedAt: string;
    analytics: boolean;
    recaptcha: boolean;
    calendly: boolean;
}

const STORAGE_KEY = 'mkp-cookie-consent';
const CURRENT_VERSION = 1;

export const OPEN_CONSENT_EVENT = 'mkp:open-cookie-consent';
export const CONSENT_CHANGED_EVENT = 'mkp:consent-changed';

export function getConsentPrefs(): CookieConsentPrefs | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as CookieConsentPrefs;
        if (parsed.version !== CURRENT_VERSION) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function saveConsentPrefs(
    prefs: Omit<CookieConsentPrefs, 'version' | 'decidedAt'>
): CookieConsentPrefs {
    const full: CookieConsentPrefs = {
        version: CURRENT_VERSION,
        decidedAt: new Date().toISOString(),
        ...prefs,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT));
    return full;
}

export function clearConsentPrefs(): void {
    localStorage.removeItem(STORAGE_KEY);
}
